/**
 * Kill switch for the onboarding documents step. The step is fully wired (presigned upload +
 * POST /organizations/{code}/attachments); this exists so the step can be turned off without a
 * revert if the backend rejects attachments from a business user on a PENDING organization.
 */
export const ORGANIZATION_DOCUMENTS_STEP_ENABLED = true;

/**
 * Documents required before review. Order matches the design.
 *
 * All of them are mandatory: the submit action stays disabled until every slot has a file, and
 * adding an entry here immediately makes that document required too.
 */
export const ORGANIZATION_DOCUMENT_SLOTS = [
  { type: "IBAN_CERTIFICATE", labelKey: "lbl_org_doc_iban" },
  { type: "NATIONAL_ADDRESS", labelKey: "lbl_org_doc_national_address" },
  { type: "COMMERCIAL_REGISTER", labelKey: "lbl_org_doc_commercial_register" },
] as const;

export const ACCEPTED_DOCUMENT_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
];

/** Mirrors the "بحد أقصى 5MB" hint in the design. */
export const MAX_DOCUMENT_SIZE_BYTES = 5 * 1024 * 1024;
